import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";
import { CSSProperties } from "react";
import { formatarPeriodo } from '../../../../domain/models/periodo_anual';

import dayjs from "dayjs";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateCadastroCoresColumns
 */

type Props = {
  onActionEditar: (idCadastroCor: number | null, openState: boolean) => void;
  onActionDeletar: (idCadastroCor: number | null, openState: boolean) => void;
};

export const GenerateCadastroCoresColumns = ({
  onActionEditar,
  onActionDeletar,
}: Props): GridColDef[] => {
  return [
    {
      field: "cor",
      filterable: false,
      headerName: "Cor",
      minWidth: 70,
      flex: 1,
      sortable: false,
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-start items-center">
          {value}
        </div>
      )
    },
    {
      field: "corValor",
      filterable: false,
      headerName: "",
      minWidth: 90,
      width: 90,
      sortable: false,
      renderCell: ({ value }) => (
        <div className="w-full h-full flex flex-col justify-center items-center">
          {value && (
            <div
              style={{
                backgroundColor: value as CSSProperties['color'] ?? 'transparent',
              }}
              className="h-[1.85rem] w-[4.0rem] rounded flex flex-col gap-0 justify-center items-center border">
              <div className="flex flex-col gap-0 justify-center items-center"></div>
            </div>
          )}
        </div>
      )
    },
    {
      field: "dataInicio",
      filterable: false,
      headerName: "Data de Inicio",
      minWidth: 135,
      width: 135,
      sortable: false,
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-start items-center">
          {value && formatarPeriodo(value)}
        </div>
      )
    },
    {
      field: "dataFinal",
      filterable: false,
      headerName: "Data de Término",
      minWidth: 135,
      width: 135,
      sortable: false,
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-start items-center">
          {value && formatarPeriodo(value)}
        </div>
      )
    },
    {
      field: "dataCadastro",
      filterable: false,
      headerName: "Data de Cadastro",
      minWidth: 135,
      width: 135,
      sortable: false,
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-start items-center">
          {value && dayjs.utc(value).local().format('DD/MM/YYYY')}
        </div>
      )
    },
    {
      field: 'idCadastroCor',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 95,
      minWidth: 95,
      resizable: false,
      renderCell: ({ value }) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onMouseDown={e => {
                onActionEditar(value, true);
                e.preventDefault();
              }}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onActionDeletar(value, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}
